import React from "react";
import HomePageStore from "../HomePageStore";
import { observer, inject } from "mobx-react";
import ImgLazyLoad from "../../ImgLazyLoad";

export interface DiscoverAndBuildTabProps {
  tabName: string;
  tabImage: string;
  tabTitle: string;
  tabIcon: string;
  tabDisclaimer?: string;
  tabMobile: boolean;
}

interface InjectedProps extends DiscoverAndBuildTabProps {
  homePageStore: HomePageStore;
}
const discoverAndBuildTab: React.SFC<DiscoverAndBuildTabProps> = (props) => {
  const { homePageStore } = props as InjectedProps;
  return (
    <div
      className="subaru_item_box"
      id={props.tabName}
      onClick={(e) => {
        homePageStore.setSelectedTab(e, props.tabMobile);
      }}
    >
      <ImgLazyLoad src={props.tabImage} />
      <div
        className={
          homePageStore.selectedTab != null &&
          homePageStore.selectedTab == props.tabName
            ? "subaru_box_title active"
            : "subaru_box_title"
        }
      >
        <h5>
          {props.tabTitle} <ImgLazyLoad src={props.tabIcon} />
        </h5>
      </div>
      {!props.tabMobile && <p>{props.tabDisclaimer}</p>}
    </div>
  );
};

export default inject("homePageStore")(observer(discoverAndBuildTab));
